import * as React from "react";
import { connect } from "react-redux";
import { IdOrientation } from "../../constants/IdOrientation";
import { IdStyles } from "../../less/IdStyles";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectRankingCurrentPosition, selectRankingIsLastPosition, selectRankingSelfName, } from "../../selectors/selectRankInfo";
import { ButtonHudNormal } from "../generic/common/ButtonHudNormal";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdModal } from "../modals/IdModal";
import { HOCRanking } from "./HOCRanking";
import { PlayerRankingCategory } from "./PlayerRankingCategory";
var getSelfEntryBtnIcn = function (activeTabIndex) {
    switch (activeTabIndex) {
        case PlayerRankingCategory.AdventurerLevelRanking:
            return IdIcon.AdventureIcn;
        case PlayerRankingCategory.CoopLevelRanking:
            return IdIcon.AllianceIcn;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return IdIcon.AllianceMemberIcn;
    }
};
var RankingButtonsDOM = function (_a) {
    var onRankingRequest = _a.onRankingRequest, selfEntryBtnDisable = _a.selfEntryBtnDisable, activeTabIndex = _a.activeTabIndex, position = _a.position, name = _a.name, isLastPosition = _a.isLastPosition;
    var _ = undefined;
    var pageUp = function () { return onRankingRequest(_, position > 10 ? position - 10 : 1); };
    var pageDown = function () { return onRankingRequest(_, position + 10); };
    var topPage = function () { return onRankingRequest(_, 1); };
    var defaultPage = function () { return onRankingRequest(name, _); };
    var selfEntryBtnIcon = getSelfEntryBtnIcn(activeTabIndex);
    var isFirstPosition = position === 1;
    return (React.createElement("div", { className: "flex flex--stacked flex--spaced v-padding__small" },
        React.createElement(ButtonHudNormal, { disabled: isFirstPosition, onClick: topPage },
            React.createElement(Icon, { icon: IdIcon.TopRankIcn, styleId: IdStyles.IconMedium })),
        React.createElement(ButtonHudNormal, { disabled: isFirstPosition, onClick: pageUp },
            React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconMedium })),
        React.createElement(ButtonHudNormal, { disabled: isLastPosition, onClick: pageDown },
            React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconMedium, orientation: IdOrientation.Down })),
        React.createElement(ButtonHudNormal, { onClick: defaultPage, disabled: selfEntryBtnDisable },
            React.createElement(Icon, { icon: selfEntryBtnIcon, styleId: IdStyles.IconMedium }))));
};
var mapState = function (state) { return ({
    activeTabIndex: selectModalTabId(state, IdModal.PlayerRanking),
    isLastPosition: selectRankingIsLastPosition(state),
    name: selectRankingSelfName(state),
    position: selectRankingCurrentPosition(state),
}); };
export var RankingButtons = connect(mapState)(HOCRanking(RankingButtonsDOM));



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/RankingButtons.tsx
// module id = 2743
// module chunks = 3